import Bb from 'backbone';
import { isUndefined } from 'underscore';

export const Filter = Bb.Model.extend({
  defaults: {
    query: ''
  },

  search(collection) {
    if (isUndefined(collection.search_params)) {
      collection.search_params = {};
    }
    collection.search_params.filter = this.get('query');
    collection.fetch({
      data: {
        filter: this.get('query')
      }
    });
  }
});



// WEBPACK FOOTER //
// ./forms/filter/model.js